module.exports = __webpack_public_path__ + "static/img/Science & Technology.0e069c3.png";